var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCatalog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 3H10C9.33696 3 8.70107 3.26339 8.23223 3.73223C7.76339 4.20107 7.5 4.83696 7.5 5.5V10.5H5V13H7.5V19.25H5V21.75H7.5V28H5V30.5H7.5V35.5C7.5 36.163 7.76339 36.7989 8.23223 37.2678C8.70107 37.7366 9.33696 38 10 38H32.5C33.163 38 33.7989 37.7366 34.2678 37.2678C34.7366 36.7989 35 36.163 35 35.5V5.5C35 4.83696 34.7366 4.20107 34.2678 3.73223C33.7989 3.26339 33.163 3 32.5 3ZM32.5 35.5H10V30.5H12.5V28H10V21.75H12.5V19.25H10V13H12.5V10.5H10V5.5H32.5V35.5Z",
    fill: "#D4C1BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10.5H27.5V13H17.5V10.5ZM17.5 19.25H27.5V21.75H17.5V19.25ZM17.5 28H27.5V30.5H17.5V28Z",
    fill: "#D4C1BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalog);
export default __webpack_public_path__ + "static/media/catalog.7fd4f17dd52e35ee842f94fe58b2127f.svg";
export { ForwardRef as ReactComponent };